import { c as _c } from "react/compiler-runtime";
import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { getMembersRoleFilterOptions, getMembersSeatFilterOptions, getMembersStatusFilterOptions, getMembersTableRoles, getMembersTypeFilterOptions } from "@components/table/members/members-filters/members-filter-options";
import { getRoleHeader, MemberHeaders } from "@components/table/members/members-table-utils";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { canUseTeamsSelector } from "@store/sdb-company/sdb-company-selector";
import { useMemberSeatsLookup } from "@hooks/use-member-seats-lookup";
import { doesPlanIncludeSeats } from "@utils/member-seats-utils";
import { doesColumnPassAnyFilter } from "@hooks/table-filters/use-apply-filter-utils";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";
import { TableType } from "@utils/track-event/track-event-list";
/** Applies the status, role, type and seat filters to the members and returns the chips to change them */
export function useMembersFilters(t0) {
  const $ = _c(24);
  const {
    members,
    tableSubject,
    canFilterByRole: t1
  } = t0;
  const canFilterByRole = t1 === undefined ? true : t1;
  const {
    getFilterIdsForColumn
  } = useFilterQueryParams();
  const tableType = useAppSelector(tableTypeSelector) ?? TableType.companyMembers;
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const {
    canViewTeams
  } = useHasUserValidRoleCompanyLevel();
  const canUseTeams = useAppSelector(canUseTeamsSelector);
  const canFilterByType = canUseTeams && canViewTeams && (tableSubject === "project" || tableSubject === "group");
  const seatsLookup = useMemberSeatsLookup();
  let t2;
  if ($[0] !== seatsLookup || $[1] !== tableSubject) {
    t2 = tableSubject === "workspace" && doesPlanIncludeSeats(seatsLookup);
    $[0] = seatsLookup;
    $[1] = tableSubject;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const canFilterBySeat = t2;
  let activeFiltersByColumn;
  let filtersByColumn;
  let t3;
  if ($[3] !== canAssignManagers || $[4] !== canFilterByRole || $[5] !== canFilterBySeat || $[6] !== canFilterByType || $[7] !== getFilterIdsForColumn || $[8] !== members || $[9] !== seatsLookup || $[10] !== tableSubject) {
    filtersByColumn = [[MemberHeaders.status, getMembersStatusFilterOptions()]];
    if (canFilterByRole) {
      filtersByColumn.push([MemberHeaders.role, getMembersRoleFilterOptions(getMembersTableRoles(tableSubject, canAssignManagers))]);
    }
    if (canFilterByType) {
      filtersByColumn.push([MemberHeaders.type, getMembersTypeFilterOptions()]);
    }
    if (canFilterBySeat) {
      filtersByColumn.push([MemberHeaders.seats, getMembersSeatFilterOptions(seatsLookup)]);
    }
    activeFiltersByColumn = filtersByColumn.map(t4 => {
      const [column, filters] = t4;
      return [column, filters, getFilterIdsForColumn(column).filter(filterId => filterId in filters)];
    });
    t3 = members.filter(member => activeFiltersByColumn.every(t5 => {
      const [, filters_0, activeFilterIds] = t5;
      return activeFilterIds.length === 0 || doesColumnPassAnyFilter({
        entity: member,
        activeFilterIds,
        allPossibleFiltersForColumn: filters_0
      });
    }));
    $[3] = canAssignManagers;
    $[4] = canFilterByRole;
    $[5] = canFilterBySeat;
    $[6] = canFilterByType;
    $[7] = getFilterIdsForColumn;
    $[8] = members;
    $[9] = seatsLookup;
    $[10] = tableSubject;
    $[11] = activeFiltersByColumn;
    $[12] = filtersByColumn;
    $[13] = t3;
  } else {
    activeFiltersByColumn = $[11];
    filtersByColumn = $[12];
    t3 = $[13];
  }
  const filteredMembers = t3;
  let t4;
  if ($[14] !== filtersByColumn || $[15] !== tableSubject || $[16] !== tableType) {
    t4 = Object.fromEntries(filtersByColumn.map(t5 => {
      const [column_0, filters_1] = t5;
      return [column_0, <DropdownFilterChip key={column_0} label={column_0 === MemberHeaders.role ? getRoleHeader(tableSubject) : column_0} filteredColumn={column_0} items={filters_1} shouldShowSearchBox={false} shouldShowCheckbox={true} shouldAllowLabelTranslation={true} tableType={tableType} />];
    }));
    $[14] = filtersByColumn;
    $[15] = tableSubject;
    $[16] = tableType;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const filterChips = t4;
  let t5;
  if ($[18] !== activeFiltersByColumn) {
    t5 = activeFiltersByColumn.filter(_temp).map(_temp2);
    $[18] = activeFiltersByColumn;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const filteredColumns = t5;
  let t6;
  if ($[20] !== filterChips || $[21] !== filteredColumns || $[22] !== filteredMembers) {
    t6 = {
      filteredMembers,
      filterChips,
      filteredColumns
    };
    $[20] = filterChips;
    $[21] = filteredColumns;
    $[22] = filteredMembers;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}
function _temp2(t0) {
  const [column_1] = t0;
  return column_1;
}
function _temp(t0) {
  const [,, activeFilterIds_0] = t0;
  return activeFilterIds_0.length > 0;
}